import { isEmptyArray } from 'formik';
import './frequency.css'
import React, { useState, useEffect, useMemo } from 'react'

export default function Frequency({ setsfrequency, variantId }) {
    const productAsItAs = JSON.parse(JSON.stringify(window.chargezenProduct));

    const variantSellingPlans = useMemo(() => {
        const currentVariant = productAsItAs?.variants?.find(v => v.id === variantId);
        const plans = [];

        if (currentVariant?.selling_plan_allocations) {
            productAsItAs?.selling_plan_groups?.forEach((sg) =>
                sg.selling_plans?.forEach((plan) => {
                    // Check if this selling plan is allocated to the current variant
                    const allocation = currentVariant.selling_plan_allocations.find(
                        a => a.selling_plan_id === plan.id
                    );
                    if (allocation) {
                        plans.push({
                            ...plan,
                            price: allocation.price
                        });
                    }
                })
            );
        }
        return plans;
    }, [variantId]);

    const [selected, setSelected] = useState(() =>
        variantSellingPlans[0]?.name || 'Select frequency'
    );

    const [isdown, setIsdown] = useState(false);

    const toggleDropDown = () => setIsdown(!isdown);

    const selectItem = (event) => {
        setSelected(event.target.textContent);
        toggleDropDown();
        const planId = event.target.getAttribute('data-sellingplan');
        console.log('Selected selling plan:', planId);
        setsfrequency(planId);
    };

    useEffect(() => {
        if (variantSellingPlans.length > 0) {
            const defaultPlanId = variantSellingPlans[0]?.id;
            if (defaultPlanId) {
                setsfrequency(defaultPlanId);
            }
        }
    }, [variantId, variantSellingPlans]);

    if (!variantSellingPlans.length) {
        return null;
    }

    return (
        <div>
            <div className="w-full">
                {/*<label className="pickup-label">Frequency</label>*/}
                <div className="w-full relative" style={{ position: 'relative' }}>
                    <div onClick={toggleDropDown} className="pickup-container">
                        <span className="text-base">{selected}</span>
                        <span className="select-arrow p-0"></span>
                    </div>
                    <div>
                        <ul className={`pickup-unorderd ${isdown ? '' : 'hidden'}`}>
                            {variantSellingPlans.map((plan) => (
                                <li
                                    key={plan.id}
                                    onClick={selectItem}
                                    data-sellingplan={plan.id}
                                    className="pickup-list"
                                >
                                    {plan.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}